import { AccountCashflow } from '../type';
import { cpsHisIdKeyFn } from './cpsHisIdKeyFn';

export const cpsHisIdKeysTransform = (v: AccountCashflow[] | undefined) => (v ? v.map((line) => cpsHisIdKeyFn(line)) : []);
